import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
export var theme = createTheme({
    palette: palette,
    typography: typography,
    components: {
        MuiAvatar: {
            styleOverrides: {
                root: {
                    width: '24px',
                    height: '24px',
                    fontSize: '12px',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#fff !important',
                    borderBottom: '1px solid #e5e8ec',
                    boxShadow: 'none',
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    background: '#rgba(27, 29, 33, .5)',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    fontWeight: 600,
                    fontSize: 14,
                    textTransform: 'none',
                    transition: 'all .25s',
                    padding: '6px 16px',
                    border: 'none',
                    minHeight: 40,
                    '&:hover': {
                        background: 'primary.main',
                        color: '#fff',
                        borderColor: 'primary.main',
                        textDecoration: 'none',
                    },
                    '&:not(:last-child)': {
                        marginRight: 18,
                    },
                    '@media (min-width: 600px)': {
                        minWidth: 'auto',
                    },
                },
                textColorPrimary: {
                    '&$selected': {
                        border: 'none',
                        background: 'primary.main',
                        color: '#fff',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    display: 'none',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    textTransform: 'none',
                    fontSize: '12px',
                },
                outlined: {
                    borderRadius: '12px',
                },
                outlinedPrimary: {
                    border: '1px solid #D6DDDF',
                    '&:hover': {
                        borderWidth: '1px',
                    },
                },
                contained: {
                    borderRadius: '12px',
                    boxShadow: 'none',
                    letterSpacing: '0.225px',
                },
                containedPrimary: {
                    color: '#fff',
                },
                text: {
                    minWidth: '120px',
                    letterSpacing: '0.225px',
                },
                sizeLarge: {
                    fontSize: '14px',
                    fontWeight: 700,
                    padding: '20px',
                    height: '56px',
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: '8px',
                },
            },
        },
        MuiButtonGroup: {
            styleOverrides: {
                contained: {
                    boxShadow: 'none',
                },
            },
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F1F5F6',
                    color: 'rgba(0, 0, 0, 0.64)',
                    border: '1px solid #D6DDDF',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    marginTop: '8px',
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#393A3C',
                    background: '#fff',
                    height: '56px',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    '&:focus': {
                        border: 'none',
                    },
                    '&$focused': {
                        border: "2px solid",
                    },
                },
                input: {
                    padding: '16px 24px',
                },
                underline: {
                    '&::before, &::after': {
                        display: 'none',
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    marginBottom: 8,
                    fontSize: 12,
                    fontWeight: 500,
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(51, 51, 51, 0.04)',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                },
                input: {
                    padding: '16px 24px',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '24px',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '32px',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '16px 32px',
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: 32,
                },
            },
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    fontSize: '.75rem',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    height: 48,
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    fontWeight: 400,
                },
                head: {
                    backgroundColor: '#FAFAFA',
                    borderRadius: 12,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                footer: {
                    border: 'none',
                },
                head: {
                    paddingLeft: 16,
                    paddingRight: 16,
                    paddingTop: 8,
                    paddingBottom: 8,
                    fontWeight: 500,
                    color: '#596877',
                    fontSize: 14,
                    border: 'none',
                    '&:first-child': {
                        borderTopLeftRadius: 12,
                        borderBottomLeftRadius: 12,
                    },
                    '&:last-child': {
                        borderTopRightRadius: 12,
                        borderBottomRightRadius: 12,
                    },
                },
                body: {
                    paddingLeft: 16,
                    paddingRight: 16,
                    paddingTop: 20,
                    paddingBottom: 20,
                    color: '#1A1A1A',
                    fontSize: 14,
                    borderColor: '#F1F1F1',
                },
            },
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    '&:not(:last-child)': {
                        marginBottom: 20,
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: '10px',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 2px 4px rgba(236, 245, 250, 0.7)',
                    border: '1px solid #e5e8ec',
                    borderRadius: '.25rem',
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    borderBottom: '1px solid #e5e8ec',
                    padding: '1.5rem',
                    background: '#fff',
                },
                title: {
                    fontWeight: 500,
                    letterSpacing: '0.225px',
                    color: '#393a3c',
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '1.5rem',
                    background: '#F9FCFD',
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    borderTop: '1px solid #e5e8ec',
                    padding: '1.5rem',
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    marginRight: 16,
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                },
            },
        },
    },
});
